import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container'




export default function AddWebsitePageComponent ({handleFormChange,networks,handleInnerFormChange, selectedPages}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Page Name"
              name="PageName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PageName',

                )
              }}
              type="text"
              value={selectedPages?.PageName}
          />
           <InputContainer
              label="Page Version Id"
              name="Page Version Id"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PageVersionId',

                )
              }}
              type="number"
              value={selectedPages?.PageVersionId}
          />
            <InputContainer
            label="Network WebPage"
                          onValueChange={(event: any) => {
                            handleInnerFormChange(
                              event,
                              'IsNetworkWebPageEnabled'
                            );
                          }}
                          type="checkbox"
                          value={selectedPages?.IsNetworkWebPageEnabled}
                      />
                      {selectedPages?.IsNetworkWebPageEnabled  && 
                            <InputContainer
                            label="Network Name" 
                                             labelField="Name"
                                             list={networks}
                                             onValueChange={( newValue: any) => {
                                               const valueData: any = newValue.map((option: any) => option?.value)
                                               handleFormChange(
                                                 valueData,
                                                 'NetworkMappings.NetworkIds',
                                                 selectedPages?.NetworkMappings
                                               );
                                             }}
                                             type="multiselect"
                                             valueField="Id"
                                             value={selectedPages?.NetworkMappings?.NetworkIds}
                         />
                      }
        <InputContainer

label="Remarks"
name="Remarks"
onValueChange={(event: any) => {
  handleInnerFormChange(
    event.target.value,
     'Remarks',

       )
     }}
 type="text"
 value={selectedPages?.Remarks}
/>
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}